<template>
  <div id="property-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>物件情報設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li>
            <span class="label">物件コード</span>
            <div class="text_contents">{{ propertyCd | blankToHyphen }}</div>
          </li>
          <li>
            <span class="label">物件名<span class="required">【必須】</span></span>
            <input type="text" v-model="propertyName" placeholder="物件名">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyName }}</div>
          </li>
          <li>
            <span class="label">物件住所</span>
            <input type="text" v-model="propertyAddress" placeholder="物件住所">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyAddress }}</div>
          </li>
          <li>
            <span class="label">見積依頼日</span>
            <input type="date" v-model="propertyEstAccountReqDate" placeholder="見積依頼日">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyEstAccountReqDate }}</div>
          </li>
          <li>
            <span class="label">見積依頼番号</span>
            <input type="text" v-model="propertyEstAccountReqNo" placeholder="見積依頼番号">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyEstAccountReqNo }}</div>
          </li>
          <li>
            <span class="label">見積回答期日</span>
            <input type="date" v-model="propertyEstAccountAnsDate" placeholder="見積回答期日">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyEstAccountAnsDate }}</div>
          </li>
          <li>
            <span class="label">顧客コード</span>
            <div class="text_contents">{{ selectedAccountPerson.ccorpClientCd | blankToHyphen }}</div>
          </li>
          <li>
            <span class="label">顧客会社名<span class="required">【必須】</span></span>
            <select v-model="selectedClientName" class="form_contents" @change="resetCorpClientPersonSelection" id="client-name">
              <option v-for="(client, index) in corpClientList" :key= index :value="client.name">
                {{client.displayName}}
              </option>
            </select>
          </li>
          <li>
            <span class="label">顧客支店名<span class="required">【必須】</span></span>
            <select v-model="selectedBranchName" class="form_contents" @change="resetCorpClientPersonSelection"
              :disabled="!corpBranchList.length">
              <option v-for="(branch, index) in corpBranchList" :key=index :value="branch.name">
                {{branch.displayName}}
              </option>
            </select>
          </li>
          <li>
            <span class="label">顧客部署名</span>
            <div class="text_contents">{{ selectedAccountPerson.ccorpClientDepartmentName | blankToHyphen }}</div>
          </li>
          <li>
            <span class="label">顧客担当者コード</span>
            <div class="text_contents">{{ selectedAccountPerson.ccorpClientPersonCd | blankToHyphen }}</div>
          </li>
          <li>
            <span class="label">顧客担当者名<span class="required">【必須】</span></span>
            <select v-model="propertyAccountPersonId" class="form_contents" ref="propertyAccountPersonSelect"
              :disabled="!corpClientPersonList.length">
              <option v-for="(person, index) in corpClientPersonList" :key= index :value="person.ccorpClientPersonId">
                {{person.ccorpClientPersonName}}
              </option>
            </select>
            <div class="validate_error_messages">{{ validateErrorMessages.propertyAccountPersonId }}</div>
          </li>
           <li>
            <span class="label">担当者１</span>
            <select v-model="propertyPersonId1" class="form_contents" ref="propertyPerson1Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
           <li>
            <span class="label">担当者２</span>
            <select v-model="propertyPersonId2" class="form_contents" ref="propertyPerson2Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
           <li>
            <span class="label">担当者３</span>
            <select v-model="propertyPersonId3" class="form_contents" ref="propertyPerson3Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
           <li>
            <span class="label">担当者４</span>
            <select v-model="propertyPersonId4" class="form_contents" ref="propertyPerson4Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
           <li>
            <span class="label">担当者５</span>
            <select v-model="propertyPersonId5" class="form_contents" ref="propertyPerson5Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
           <li>
            <span class="label">担当者６</span>
            <select v-model="propertyPersonId6" class="form_contents" ref="propertyPerson6Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
           <li>
            <span class="label">担当者７</span>
            <select v-model="propertyPersonId7" class="form_contents" ref="propertyPerson7Select">
              <option value=""></option>
              <option v-for="(person, index) in userAccountList" :key= index :value="person.cuserId" >{{person.fullName}}</option>
            </select>
          </li>
          <li>
            <span class="label">見積表示備考1</span>
            <select v-model="propertyEstRemark1Cd" class="form_contents" ref="propertyEstRemark1Select">
              <option value=""></option>
              <option v-for="(remark, index) in estimateRemarkCodeList" :key= index :value="remark.codeValue">
                {{ remark.codeTextLong }}
              </option>
            </select>
            <div class="validate_error_messages">{{ validateErrorMessages.propertyEstRemark1Cd }}</div>
          </li>
          <li>
            <span class="label">見積表示備考2</span>
            <input type="text" v-model="propertyEstRemark2" placeholder="見積表示備考2">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyEstRemark2 }}</div>
          </li>
           <li>
            <span class="label">社内参照用備考</span>
            <input type="text" v-model="propertyRemark" placeholder="社内参照用備考">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyRemark }}</div>
          </li>
           <li>
            <span class="label">コメント1</span>
            <input type="text" v-model="propertyComment1" placeholder="コメント1">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyComment1 }}</div>
          </li>
           <li>
            <span class="label">コメント2</span>
            <input type="text" v-model="propertyComment2" placeholder="コメント2">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyComment2 }}</div>
          </li>
           <li>
            <span class="label">コメント3</span>
            <input type="text" v-model="propertyComment3" placeholder="コメント3">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyComment3 }}</div>
          </li>
           <li>
            <span class="label">掛率1</span>
            <input type="number" v-model="propertyProb1" placeholder="掛率1">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyProb1 }}</div>
          </li>
          <li>
            <span class="label">掛率2</span>
            <input type="number" v-model="propertyProb2" placeholder="掛率2">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyProb2 }}</div>
          </li>
          <li>
            <span class="label">納期N日数</span>
            <input type="number" v-model="propertyNDays" placeholder="納期N日数">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyNDays }}</div>
          </li>
          <li>
            <span class="label">受注日</span>
            <input type="date" v-model="propertyOrderDate" placeholder="受注日">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyOrderDate }}</div>
          </li>
          <li>
            <span class="label">注文番号</span>
            <input type="text" v-model="propertyOrderNo" placeholder="注文番号">
            <div class="validate_error_messages">{{ validateErrorMessages.propertyOrderNo }}</div>
          </li>
        </ul>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" v-if="propertyId" @click="updatePropertyData">設定</button>
      <button type="button" class="main_btn" v-else @click="updatePropertyData">登録</button>
      <button type="button" class="main_btn" v-if="propertyId" @click="confirmDelete">削除</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'PropertyModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    clientPersonList: Array,
    userAccountList: Array,
    estimateRemarkCodeList: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 物件情報 */
      propertyId: null,
      propertyCd: null,
      propertyName: null,
      propertyAddress: null,
      propertyEstAccountReqDate: null,
      propertyEstAccountReqNo: null,
      propertyEstAccountAnsDate: null,
      propertyAccountPersonId: null,
      propertyPersonId1: null,
      propertyPersonId2: null,
      propertyPersonId3: null,
      propertyPersonId4: null,
      propertyPersonId5: null,
      propertyPersonId6: null,
      propertyPersonId7: null,
      propertyEstRemark1Cd: null,
      propertyEstRemark2: null,
      propertyRemark: null,
      propertyComment1: null,
      propertyComment2: null,
      propertyComment3: null,
      propertyProb1: null,
      propertyProb2: null,
      propertyNDays: null,
      propertyOrderDate: null,
      propertyOrderNo: null,
      /** 選択中の担当者 */
      validateErrorMessages: {},
      /** 選択した顧客会社名 */
      selectedClientName: null,
      /** 選択した顧客支社名 */
      selectedBranchName: null
    }
  },
  filters: {
    blankToHyphen: function (value) {
      if (!value) {
        return '-'
      }
      return value
    }
  },
  computed: {
    /** 顧客会社名リスト */
    corpClientList: function () {
      const clientMap = new Map()
      for (const person of this.clientPersonList) {
        // null/空文字/空白文字のみは同一視する
        const clientName = person.ccorpClientName === null ? '' : person.ccorpClientName.trim()
        const clientInfo = {
          name: clientName,
          displayName: clientName === '' ? '登録なし' : clientName
        }
        clientMap.set(clientInfo.name, clientInfo)
      }
      return Array.from(clientMap.values()).sort(this.sortByNameBlanksLast)
    },
    corpBranchList: function () {
      const branchMap = new Map()
      for (const person of this.clientPersonList) {
        const clientName = person.ccorpClientName === null ? '' : person.ccorpClientName.trim()
        if (clientName === this.selectedClientName) {
          const branchName = person.ccorpClientBranchName === null ? '' : person.ccorpClientBranchName.trim()
          const branchInfo = {
            name: branchName,
            displayName: branchName === '' ? '登録なし' : branchName
          }
          branchMap.set(branchInfo.name, branchInfo)
        }
      }
      return Array.from(branchMap.values()).sort(this.sortByNameBlanksLast)
    },
    corpClientPersonList: function () {
      return this.clientPersonList.filter(person => {
        const clientName = person.ccorpClientName === null ? '' : person.ccorpClientName.trim()
        const branchName = person.ccorpClientBranchName === null ? '' : person.ccorpClientBranchName.trim()
        return clientName === this.selectedClientName && branchName === this.selectedBranchName
      })
    },
    /** 選択中の顧客担当者 */
    selectedAccountPerson: {
      get () {
        let person = this.clientPersonList.find(person => person.ccorpClientPersonId === this.propertyAccountPersonId)
        if (!person) {
          return {
            ccorpClientPersonId: null,
            ccorpClientCd: null,
            ccorpClientName: null,
            ccorpClientBranchName: null,
            ccorpClientDepartmentName: null,
            ccorpClientPersonCd: null,
            ccorpClientPersonName: null
          }
        }
        return person
      },
      set (value) {
        this.propertyAccountPersonId = value
      }
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function () {
      this.clearData()
      this.modalShown = true
    },
    /** 編集モーダル */
    showEditModal: function (data) {
      this.propertyId = data.cpropertyId
      this.propertyCd = data.cpropertyCd
      this.propertyName = data.cpropertyName
      this.propertyAddress = data.cpropertyAddress
      this.propertyEstAccountReqDate = this.getFormatDate(data.cpropertyEstAccountReqDate)
      this.propertyEstAccountReqNo = data.cpropertyEstAccountReqNo
      this.propertyEstAccountAnsDate = this.getFormatDate(data.cpropertyEstAccountAnsDate)
      this.propertyAccountPersonId = data.cpropertyAccountPersonId
      if (this.selectedAccountPerson.ccorpClientPersonId) {
        this.selectedClientName = this.selectedAccountPerson.ccorpClientName === null ? '' : this.selectedAccountPerson.ccorpClientName.trim()
        this.selectedBranchName = this.selectedAccountPerson.ccorpClientBranchName === null ? '' : this.selectedAccountPerson.ccorpClientBranchName.trim()
      }
      this.propertyPersonId1 = data.cpropertyPersonId1
      this.propertyPersonId2 = data.cpropertyPersonId2
      this.propertyPersonId3 = data.cpropertyPersonId3
      this.propertyPersonId4 = data.cpropertyPersonId4
      this.propertyPersonId5 = data.cpropertyPersonId5
      this.propertyPersonId6 = data.cpropertyPersonId6
      this.propertyPersonId7 = data.cpropertyPersonId7
      this.propertyEstRemark1Cd = data.cpropertyEstRemark1Cd
      this.propertyEstRemark2 = data.cpropertyEstRemark2
      this.propertyRemark = data.cpropertyRemark
      this.propertyComment1 = data.cpropertyComment1
      this.propertyComment2 = data.cpropertyComment2
      this.propertyComment3 = data.cpropertyComment3
      this.propertyProb1 = data.cpropertyProb1
      this.propertyProb2 = data.cpropertyProb2
      this.propertyNDays = data.cpropertyNDays
      this.propertyOrderDate = this.getFormatDate(data.cpropertyOrderDate)
      this.propertyOrderNo = data.cpropertyOrderNo
      this.propertyOrderStatus = data.cpropertyOrderStatus
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** 物件情報更新 */
    updatePropertyData: function () {
      let validList = []
      this.validateErrorMessages = {}
      validList.push(this.validPropertyProb(this.propertyProb1, 'propertyProb1', '掛率１'))
      validList.push(this.validPropertyProb(this.propertyProb2, 'propertyProb2', '掛率２'))
      validList.push(this.validPropertyNDays(this.propertyNDays, 'propertyNDays', '納期N日数'))
      let isValid = true
      validList.forEach(e => {
        if (!e) {
          isValid = e
        }
      })
      if (!isValid) { return }
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        propertyId: this.propertyId,
        propertyName: this.propertyName,
        propertyAddress: this.propertyAddress,
        propertyEstAccountReqDate: this.propertyEstAccountReqDate,
        propertyEstAccountReqNo: this.propertyEstAccountReqNo,
        propertyEstAccountAnsDate: this.propertyEstAccountAnsDate,

        // 顧客担当者・担当者のIDが設定されているがselect要素が未選択状態の場合、削除済のIDであるため同じIDでの上書き更新はしない
        propertyAccountPersonId: this.$refs.propertyAccountPersonSelect.selectedIndex !== -1 ? this.propertyAccountPersonId : null,
        propertyPersonId1: this.$refs.propertyPerson1Select.selectedIndex !== -1 ? this.propertyPersonId1 : null,
        propertyPersonId2: this.$refs.propertyPerson2Select.selectedIndex !== -1 ? this.propertyPersonId2 : null,
        propertyPersonId3: this.$refs.propertyPerson3Select.selectedIndex !== -1 ? this.propertyPersonId3 : null,
        propertyPersonId4: this.$refs.propertyPerson4Select.selectedIndex !== -1 ? this.propertyPersonId4 : null,
        propertyPersonId5: this.$refs.propertyPerson5Select.selectedIndex !== -1 ? this.propertyPersonId5 : null,
        propertyPersonId6: this.$refs.propertyPerson6Select.selectedIndex !== -1 ? this.propertyPersonId6 : null,
        propertyPersonId7: this.$refs.propertyPerson7Select.selectedIndex !== -1 ? this.propertyPersonId7 : null,
        // 見積書備考1も同様
        propertyEstRemark1Cd: this.$refs.propertyEstRemark1Select.selectedIndex !== -1 ? this.propertyEstRemark1Cd : null,

        propertyEstRemark2: this.propertyEstRemark2,
        propertyRemark: this.propertyRemark,
        propertyComment1: this.propertyComment1,
        propertyComment2: this.propertyComment2,
        propertyComment3: this.propertyComment3,
        propertyProb1: this.propertyProb1,
        propertyProb2: this.propertyProb2,
        propertyNDays: this.propertyNDays,
        propertyOrderDate: this.propertyOrderDate,
        propertyOrderNo: this.propertyOrderNo,
        propertyOrderStatus: this.propertyOrderStatus === null ? 0 : this.propertyOrderStatus
      }
      if (!this.propertyId) {
        axios.post(API_URL.PROPERTY + '/add', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['登録しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getPropertyList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      } else {
        axios.post(API_URL.PROPERTY + '/update', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['変更しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getPropertyList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    /** 削除確認 */
    confirmDelete: function () {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.deleteSubmit
      }
      AppUtil.showModal(modalData)
    },
    /** 物件情報削除 */
    deleteSubmit: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        targetId: this.propertyId
      }
      axios.post(API_URL.PROPERTY + '/delete', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        this.showModal = false
        let modalData = {
          messages: ['削除しました。'],
          onOk: () => {
            this.modalShown = false
            this.$emit('getPropertyList')
          }
        }
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    /** 掛率入力チェック */
    validPropertyProb: function (prob, key, errorMessage) {
      let num = String(prob).split('.')[1]
      let digit = (num) ? num.length : 0
      if (prob && digit > 3) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は4桁以下で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    /** 納期N日程入力チェック */
    validPropertyNDays: function (days, key, errorMessage) {
      if (days && String(days).length > 3) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は999以下の整数で入力してください。')
        return false
      }
      var pattern = /^[0-9]+$/
      if (days && !pattern.test(days)) {
        this.$set(this.validateErrorMessages, key, errorMessage + 'は1以上の整数で入力してください。')
        return false
      }
      this.$set(this.validateErrorMessages, key, '')
      return true
    },
    clearData: function () {
      this.propertyId = null
      this.propertyCd = null
      this.propertyName = null
      this.propertyAddress = null
      this.propertyEstAccountReqDate = null
      this.propertyEstAccountReqNo = null
      this.propertyEstAccountAnsDate = null
      this.propertyAccountPersonId = null
      this.propertyPersonId1 = null
      this.propertyPersonId2 = null
      this.propertyPersonId3 = null
      this.propertyPersonId4 = null
      this.propertyPersonId5 = null
      this.propertyPersonId6 = null
      this.propertyPersonId7 = null
      this.propertyEstRemark1Cd = null
      this.propertyEstRemark2 = null
      this.propertyRemark = null
      this.propertyComment1 = null
      this.propertyComment2 = null
      this.propertyComment3 = null
      this.propertyProb1 = null
      this.propertyProb2 = null
      this.propertyNDays = null
      this.propertyOrderStatus = null
      this.selectedAccountPerson = null
      this.validateErrorMessages = {}
      this.selectedClientName = null
      this.selectedBranchName = null
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    sortByNameBlanksLast: function (a, b) {
      // keyが空文字の項目（登録なし）は一番後に並べ替える
      if (a.name === '') return 1
      if (b.name === '') return -1
      // それ以外は辞書順
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    },
    resetCorpClientPersonSelection: function (event) {
      this.propertyAccountPersonId = null
      if (event.target.id === 'client-name') {
        this.selectedBranchName = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  input{
    min-width: 250px;
  }
  .form_contents{
    // select項目のサイズに上限を設定しないと表示が崩れる
    width: 274px;
  }
  .text_contents{
    min-width: 250px;
  }
}
.data-area {
  padding: 20px;
  max-height: 620px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
  min-width: 550px;
}
.count_limit{
  font-size: 8px;
}
.required {
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/PropertyModal.vue